import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `GrupoVerraco/getFiltrarGrupoVerraco`, method: 'POST', body: values, token: token})
}
